import React, { useState, useEffect } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { TransactionCard } from '../TransactionCard/TransactionCard';
import styles from './TransactionList.module.css';

interface Transaction {
  tscId: number;
  tscName: string;
  tccId: number;
  tccName: string;
  tscValue: number;
  tctId: 1 | 2;
  tctName: "Saída" | "Entrada";
  tscMonth: number;
  tscYear: number;
  tscRecurrence: number;
  tscRecurrenceDate: string;
  tscDateCreated: string;
  tscVersion: number;
  tscIdInitVersion: number;
  usrId: number;
  usrIdTransaction: number;
  usrName: string;
  tscCheck: number;
}

interface TransactionListProps {
  transactions: Transaction[];
  isMonthClosed: boolean;
  onDelete: (id: number) => void;
  onUpdateCheck: (id: number, checked: number) => void;
  onUpdateValue: (id: number, value: number) => void;
  onDeleteConfirm: (event: React.MouseEvent<HTMLButtonElement>, id: number) => void;
  onCheckConfirm: (event: React.MouseEvent<HTMLElement>, id: number, checked: number) => void;
  children?: React.ReactNode; // Para renderizar a tabela quando não for mobile
}

export function TransactionList({
  transactions,
  isMonthClosed,
  onDelete,
  onUpdateCheck,
  onUpdateValue,
  onDeleteConfirm,
  onCheckConfirm,
  children,
}: TransactionListProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md')); // 768px
  const [shouldShowCards, setShouldShowCards] = useState(false);

  useEffect(() => {
    setShouldShowCards(isMobile);
  }, [isMobile]);

  if (shouldShowCards) {
    return (
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        gap: 2, 
        p: 2,
        width: '100%',
        minHeight: 200
      }}>
        {transactions.map((transaction) => (
          <TransactionCard
            key={transaction.tscId}
            transaction={transaction}
            isMonthClosed={isMonthClosed}
            onDelete={onDelete}
            onUpdateCheck={onUpdateCheck}
            onUpdateValue={onUpdateValue}
            onDeleteConfirm={onDeleteConfirm}
            onCheckConfirm={onCheckConfirm}
          />
        ))}
      </Box>
    );
  }

  // Renderiza a tabela original para desktop
  return <>{children}</>;
}